import { formatDate, DATE_FORMATS } from '@frontend/mwm-ui'

import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { IUserPublic } from '~/types/user'

import UserCard from '~/components/UserCard'
import { MILLISECONDS_IN_NANO } from '~/const'
import { capitalize } from '~/utils/string'

const LastUpdateCellRenderer = ({
  data,
}: ICellRendererParams<{
  updated_at_ts: number | string
  updated_by?: Pick<IUserPublic, 'name' | 'picture'>
}>): ReactElement => {
  if (!data) return <div />

  const { updated_at_ts, updated_by } = data

  if (!updated_by) return <div />

  const { name, picture } = updated_by

  const getSubInfo = formatDate(
    typeof updated_at_ts === 'string' ? updated_at_ts : updated_at_ts / MILLISECONDS_IN_NANO,
    DATE_FORMATS.DEFAULT_WITH_HOURS
  )

  return (
    <div className="last-update-cell">
      <UserCard name={capitalize(name)} picture={picture} size="small" subInfo={getSubInfo} />
    </div>
  )
}

export const LastUpdateCellRendererV2 = ({
  value,
}: ICellRendererParams<
  unknown,
  {
    updated_at: number
    updated_by?: Pick<IUserPublic, 'name' | 'picture'>
  }
>): ReactElement => {
  if (!value) return <div />

  const { updated_at, updated_by } = value

  if (!updated_by) return <div />

  const { name, picture } = updated_by

  return (
    <div className="last-update-cell">
      <UserCard name={capitalize(name)} picture={picture} size="small" subInfo={formatDate(updated_at)} />
    </div>
  )
}

export default LastUpdateCellRenderer
